"use client";

import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { Badge, Chip, Skeleton } from "@mui/material";
import { DateRangeContext } from "../CustomDateRangePicker";
import { hitsOptions } from "@/queryOptions/hits";

const CountBadge = ({
  term,
  encodedFilterParams,
}: {
  term: string;
  encodedFilterParams: string;
}) => {
  const { dateRange } = useContext(DateRangeContext);

  const queryParams = new URLSearchParams({
    term: term,
    "filter-params": encodedFilterParams,
  });

  if (dateRange[0]) {
    queryParams.append(
      "date-range",
      `${dateRange[0]?.startOf("day").valueOf()}`,
    );
    if (dateRange[1]) {
      queryParams.append(
        "date-range",
        `${dateRange[1]?.endOf("day").valueOf()}`,
      );
    }
  }

  const { data, isLoading } = useQuery(hitsOptions(queryParams));

  return (
    <Badge
      badgeContent={
        isLoading ? (
          <Skeleton width="2ch" className="bg-secondary-light" />
        ) : (
          `${data}`
        )
      }
      color="secondary"
      slotProps={{
        badge: {
          className: "transform-none relative h-4 min-w-4 px-1 mr-1",
        },
      }}
      max={999}
    />
  );
};

const TermChip = ({
  name,
  term,
  encodedFilterParams,
  showCountBadge = false,
  onDelete,
}: {
  name: string;
  term: string;
  encodedFilterParams?: string;
  showCountBadge?: boolean;
  onDelete: () => void;
}) => {
  return (
    <Chip
      label={
        <>
          {showCountBadge && encodedFilterParams && (
            <CountBadge term={term} encodedFilterParams={encodedFilterParams} />
          )}
          {term}
          <input type="hidden" name={name} value={term} />
        </>
      }
      className="bg-secondary-50"
      onDelete={onDelete}
    />
  );
};

export default TermChip;
